export default __webpack_public_path__ + "static/media/work_4.45d6e2ab.jpg";